import { render } from "./PcHome.vue?vue&type=template&id=22ac784b&scoped=true"
import script from "./PcHome.vue?vue&type=script&lang=js"
export * from "./PcHome.vue?vue&type=script&lang=js"

import "./PcHome.vue?vue&type=style&index=0&id=22ac784b&scoped=true&lang=css"

import exportComponent from "D:\\workSpace\\myself\\tom\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ac784b"]])

export default __exports__